(function (global) {
  "use strict";

  var DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;
  var cache = Object.create(null);

  function normalizeTimeZone(value) {
    var candidate = String(value || "").trim() || "UTC";
    try {
      new Intl.DateTimeFormat("en-US", { timeZone: candidate }).format(0);
      return candidate;
    } catch (error) {
      return "UTC";
    }
  }

  function browserTimeZone() {
    try {
      return normalizeTimeZone(
        new Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC",
      );
    } catch (error) {
      return "UTC";
    }
  }

  function formatter(timeZone, includeTime) {
    var key = timeZone + ":" + (includeTime ? "datetime" : "date");
    if (cache[key]) return cache[key];
    var options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      timeZone: timeZone,
    };
    if (includeTime) {
      options.hour = "numeric";
      options.minute = "2-digit";
      options.timeZoneName = "short";
    }
    cache[key] = new Intl.DateTimeFormat(undefined, options);
    return cache[key];
  }

  function format(value, options) {
    if (!value) return "";
    options = options || {};
    var raw = String(value);
    if (DATE_ONLY.test(raw)) {
      var calendarDate = new Date(raw + "T00:00:00Z");
      return isNaN(calendarDate.getTime())
        ? raw
        : formatter("UTC", false).format(calendarDate);
    }
    var parsed = new Date(raw);
    if (isNaN(parsed.getTime())) return raw;
    var timeZone = options.timeZone
      ? normalizeTimeZone(options.timeZone)
      : browserTimeZone();
    return formatter(timeZone, options.includeTime === true).format(parsed);
  }

  function formatTime(value, options) {
    if (!value) return "";
    options = options || {};
    var parsed = new Date(String(value));
    if (isNaN(parsed.getTime())) return String(value);
    var timeZone = options.timeZone
      ? normalizeTimeZone(options.timeZone)
      : browserTimeZone();
    return new Intl.DateTimeFormat(undefined, {
      hour: "numeric",
      minute: "2-digit",
      timeZoneName: "short",
      timeZone: timeZone,
    }).format(parsed);
  }

  global.BBDashboardTime = {
    browserTimeZone: browserTimeZone,
    format: format,
    formatTime: formatTime,
    normalizeTimeZone: normalizeTimeZone,
  };
})(window);
